export const environment = {
  production: false,
  apiUrl: 'https://localhost:3000/graphql/',
  imgUrl: 'https://localhost:3000/',
  apiUploadImage: 'https://web.medilink.com.ec:8443/uploads/uploadImage',
  apiUploadDocuments: 'http://192.168.1.2:8089/xml/comprasOrdenes/uploadDocument',
  apiGetDataOfOrden: 'http://192.168.1.2:8089/xml/comprasOrdenes/checkExistence',
  apiGetDataOfProveedor: 'http://192.168.1.2:8089/xml/proveedores/dataOfProveedor',
  apiCheckUrl: 'http://192.168.1.2:8089/xml/comprasOrdenes/validateLink',
  apiSendPQRS: 'http://localhost:3000/send-email/pqrs',
  apiDeleteDocument: 'https://www.medilink.com.ec:8089/xml/comprasOrdenes/uploadStatusOfDocument'
};
